class MouseManager {
  constructor(initiator) {
    this.initiator = initiator;

    this.mouseDownHandler = (event) => { this.down(event); };
  }

  addEvents() {
    this.initiator.DOMElement.addEventListener('mousedown', this.mouseDownHandler);
  }

  removeEvents() {
    this.initiator.DOMElement.removeEventListener('mousedown', this.mouseDownHandler);
  }

  down() {
    this.initiator.action();
  }
}

export default MouseManager;
